import { Order, OrderDelivery } from '@restaurant/api';
import { OrderType } from '@restaurant/types';
import React, { createContext, useMemo, useState } from 'react';

export type NewOrder = {
  isNew: true;
  orderType: OrderType | null;
  tableNumber: number | null;
  customerName: string | null;
  delivery: OrderDelivery | null;
};

export type OrderContextValue = {
  order: (Order & { isNew?: false }) | NewOrder;
  setOrder: (params: Order | NewOrder) => void;
  newOrder: () => void;
};

const createNewOrder = (): NewOrder => ({
  isNew: true,
  orderType: null,
  tableNumber: null,
  customerName: null,
  delivery: null,
});

export const OrderContext = createContext<OrderContextValue>({
  order: createNewOrder(),
  setOrder: () => {},
  newOrder: () => {},
});

export const OrderProvider = ({ children }: { children: React.ReactNode }) => {
  const [order, setOrder] = useState<Order | NewOrder>(createNewOrder());
  const value = useMemo(() => {
    return {
      order,
      setOrder,
      newOrder: () => {
        setOrder(createNewOrder());
      },
    };
  }, [order, setOrder]);

  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};
